import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { ReactiveFormsModule } from "@angular/forms";
import { MaterialModule } from "src/app/material.module";
import { provideNativeDateAdapter } from "@angular/material/core";
import { DateAdapter } from "@angular/material/core";
import { MonthpickerDateAdapter } from "../month-datepicker/month-datepicker.component";
import { Platform } from "@angular/cdk/platform";
import { MAT_DATE_LOCALE } from "@angular/material/core";
import { ChangeDetectorRef, Component, EventEmitter, Input, Output, SimpleChanges } from "@angular/core";
import { HelperService } from "../../services/helper.service";
import { RegistreService } from "../../services/registre.service";
import { DealsService } from "../../services/deals.service";
import { MsalService } from "@azure/msal-angular";
import { DomSanitizer } from "@angular/platform-browser";
import { AuthService } from "../../services/auth.service";
import { OfficeoauthService } from "../../services/officeoauth.service";
import { Router, RouterModule } from "@angular/router";
import { Searchpost } from '../../models/searchpost';
import { BehaviorSubject, Observable, switchMap } from "rxjs";
import { ContactService } from "../../services/contact.service";
import { CorporateService } from "../../services/corporate.service";
import { CompanyService } from "../../services/company.service";
import {
    getAppointmentCreator,
    getAppointmentRoleClass,
    getAppointmentRoleLabel,
    getAfsUserDisplayName,
    getInvitedAfsParticipants,
} from 'src/app/core/utils/appointment-afs-roles';

@Component({
    selector: 'app-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, MaterialModule, RouterModule],
    providers: [
        provideNativeDateAdapter(),
        {
            provide: DateAdapter,
            useClass: MonthpickerDateAdapter,
            deps: [MAT_DATE_LOCALE, Platform],
        },
    ]
})
export class SearchComponent {
    searchType: string = 'Corporate';
    searchTerm: string;
    searchpost: Searchpost = new Searchpost();
    resultatsearch$: Observable<any> | null;
    refreshResult$ = new BehaviorSubject<boolean>(true);
    refreshEvent$ = new BehaviorSubject<boolean>(true);
    group: any;
    currentUser: any;
    @Input() searchOverlayActive: boolean = false;
    @Output() searchOverlayActiveChange = new EventEmitter<boolean>();

    constructor(
        private cd: ChangeDetectorRef,
        private registreservice: RegistreService,
        public helper: HelperService,
        private authServiceMsal: MsalService,
        private authService: AuthService,
        private dealservice: DealsService,
        private officeoauthservice: OfficeoauthService,
        private domSanitizer: DomSanitizer,
        private router: Router,
        private contactservice: ContactService,
        private companyservice: CompanyService
    ) { }

    ngOnInit() {
        this.currentUser = this.authService.currentUser();
        if (this.currentUser) {
            this.group = this.currentUser.group;
        }
        else {
            this.group = [];
        }
    }

    ngOnDestroy() {
        this.searchOverlayActive = false;
        this.searchOverlayActiveChange.emit(this.searchOverlayActive);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['searchOverlayActive']) {
            this.searchType = 'Corporate';
            this.searchTerm = '';
            this.searchpost = new Searchpost();
            this.resultatsearch$ = null;
        }
    }

    closereset() {
        this.searchOverlayActive = false;
        this.searchOverlayActiveChange.emit(this.searchOverlayActive);
    }

    closeSearch() {
        this.searchOverlayActive = false;
        this.searchOverlayActiveChange.emit(this.searchOverlayActive);
    }

    navigateTo(url: string) {
        this.closeSearch();
        const currentPath = this.router.url.split('?')[0];
        const targetPath = url.split('?')[0];
        const routeBase = (path: string) => path.replace(/\/[^/]+$/, '');
        const sameComponent = routeBase(currentPath) === routeBase(targetPath) && currentPath !== targetPath;
        if (sameComponent) {
            this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
                this.router.navigateByUrl(url)
            );
        } else {
            this.router.navigateByUrl(url);
        }
    }

    toggleClasss() {
        this.searchOverlayActive = !this.searchOverlayActive;
        this.searchOverlayActiveChange.emit(this.searchOverlayActive);
    }

    onSearch(event): void {
        if (event && event.length >= 3) {
            this.searchpost.slug = event;
            switch (this.searchType) {
                case 'Opportunities':
                    // Logique de recherche pour les opportunités
                    this.resultatsearch$ = this.refreshResult$.pipe(
                        switchMap(_ =>
                            this.dealservice.searchOpportunities(this.searchpost)
                        )
                    );

                    break;
                case 'Deals':
                    // Logique de recherche pour les deals
                    this.resultatsearch$ = this.refreshResult$.pipe(
                        switchMap(_ => this.dealservice.searchDeals(this.searchpost))
                    );

                    break;
                case 'Corporate':
                    // Logique de recherche pour corporate
                    this.resultatsearch$ = this.refreshResult$.pipe(
                        switchMap(_ => this.companyservice.searchCorporate(this.searchpost))
                    );

                    break;
                case 'Contacts':
                    // Logique de recherche pour corporate
                    this.resultatsearch$ = this.refreshResult$.pipe(
                        switchMap(_ => this.contactservice.searchContact(this.searchpost))
                    );

                    break;
                case 'Lenders':
                    // Logique de recherche pour corporate
                    this.resultatsearch$ = this.refreshResult$.pipe(
                        switchMap(_ => this.dealservice.searchLenders(this.searchpost))
                    );

                    break;
                case 'Appointments':
                    // Logique de recherche pour les appointments
                    this.resultatsearch$ = this.refreshResult$.pipe(
                        switchMap(_ => this.dealservice.searchAppointments(this.searchpost))
                    );

                    break;
                // ... et ainsi de suite pour les autres types
            }
        } else {
            this.resultatsearch$ = null;
        }
    }

    onSearchTypeChanged() {
        this.onSearch(this.searchTerm);
    }

    getParticipantDisplayName(participant: any): string {
        if (!participant) return '';

        const contactName = (participant.contact_name ?? '').toString().trim();
        if (contactName) return contactName;

        const firstName = (participant.first_name ?? participant.forename ?? '').toString().trim();
        const lastName = (participant.last_name ?? participant.name ?? '').toString().trim();
        const fullName = `${firstName} ${lastName}`.trim();
        if (fullName) return fullName;

        const email = (participant.email ?? '').toString().trim();
        if (email) return email;

        return '';
    }

    private isAfsParticipant(participant: any): boolean {
        if (!participant) return false;

        return participant.is_afs === true
            || participant.participant_type === 'afs'
            || participant.source === 'afs'
            || participant.role === 'afs'
            || participant.afs_user_id !== undefined
            || (participant.contact_id === undefined
                && participant.contact_name === undefined
                && (participant.first_name || participant.last_name)
                && participant.slug);
    }

    private deduplicateParticipants(participants: any[]): any[] {
        const seen = new Set<string>();
        const unique: any[] = [];

        for (const participant of participants || []) {
            const slug = (participant?.slug ?? '').toString().trim().toLowerCase();
            const afsUserId = (participant?.afs_user_id ?? '').toString().trim();
            const contactId = (participant?.contact_id ?? '').toString().trim();
            const email = (participant?.email ?? '').toString().trim().toLowerCase();
            const displayName = this.getParticipantDisplayName(participant).toLowerCase();

            const key =
                slug
                    ? `slug:${slug}`
                    : afsUserId
                        ? `afs:${afsUserId}`
                        : contactId
                            ? `contact:${contactId}`
                            : email
                                ? `email:${email}`
                                : `name:${displayName}`;

            if (!seen.has(key)) {
                seen.add(key);
                unique.push(participant);
            }
        }

        return unique;
    }

    getExternalParticipants(result: any): any[] {
        const participants = Array.isArray(result?.list_of_participant) ? result.list_of_participant : [];
        const externalParticipants = participants.filter((participant: any) => !this.isAfsParticipant(participant));
        return this.deduplicateParticipants(externalParticipants);
    }

    getAfsParticipants(result: any): any[] {
        const dedicatedAfs = Array.isArray(result?.list_of_participant_afs) ? result.list_of_participant_afs : [];
        if (dedicatedAfs.length > 0) return this.deduplicateParticipants(dedicatedAfs);

        const participants = Array.isArray(result?.list_of_participant) ? result.list_of_participant : [];
        const afsParticipants = participants.filter((participant: any) => this.isAfsParticipant(participant));
        return this.deduplicateParticipants(afsParticipants);
    }

    getAppointmentCreatorLabel = getAppointmentRoleLabel;
    getAppointmentCreatorClass = getAppointmentRoleClass;
    getAppointmentInvitedClass = getAppointmentRoleClass;
    getAppointmentInvitedLabel = getAppointmentRoleLabel;
    getAfsUserDisplayName = getAfsUserDisplayName;

    getSearchAppointmentCreator(result: any): { name: string } | null {
        const creatorSlug = result?.slug_busdev_in_charge;
        const afsList = Array.isArray(result?.list_of_participant_afs)
            ? result.list_of_participant_afs
            : [];
        const creator = getAppointmentCreator(creatorSlug, afsList, null);
        const name = (result?.busdevname || '').toString().trim()
            || getAfsUserDisplayName(creator);
        if (!name) {
            return null;
        }
        return { name };
    }

    getSearchInvitedAfsParticipants(result: any): any[] {
        return getInvitedAfsParticipants(
            result?.slug_busdev_in_charge,
            this.getAfsParticipants(result)
        );
    }

    isGenericContact(contact: any): boolean {
        if (!contact) return false;
        return contact?.is_generic === true || contact?.is_generic === 1 || contact?.is_generic === '1';
    }
}